import React from 'react'

export const kentuckySetupVars = {
  siteId: 'kentucky',
  pathPrefix: '/ky',
  menuHeader: "Discover Kentucky's Solution for:",
  appUrl: 'https://ky.headed2.com',
  logoImg: '/images/assets/kentucky/horizontal/dark.svg',
  headerTitle: `The Kentucky CareerExplorer is a system designed for Kentucky`
}
